export var VehicleType;
(function (VehicleType) {
    VehicleType["MOTORBIKE"] = "motorbike";
    VehicleType["MOPED"] = "motorcycle";
})(VehicleType || (VehicleType = {}));
(function (VehicleType) {
    function createOptions(t) {
        return [
            {
                label: t('wheelie:form.vehicles.vehicleType.motorrad'),
                value: VehicleType.MOTORBIKE,
            },
            {
                label: t('wheelie:form.vehicles.vehicleType.moped'),
                value: VehicleType.MOPED,
            },
        ];
    }
    VehicleType.createOptions = createOptions;
    function getValues() {
        return [VehicleType.MOTORBIKE, VehicleType.MOPED];
    }
    VehicleType.getValues = getValues;
})(VehicleType || (VehicleType = {}));
export var EngineType;
(function (EngineType) {
    EngineType["ELECTRO"] = "electro";
    EngineType["FUELCELL"] = "fuelCell";
    EngineType["GAS"] = "gas";
    EngineType["HYBRID"] = "hybrid";
    EngineType["ICE"] = "ice";
})(EngineType || (EngineType = {}));
(function (EngineType) {
    function createOptions(t) {
        return [
            {
                label: t('wheelie:form.vehicles.engineType.ice'),
                value: EngineType.ICE,
            },
            {
                label: t('wheelie:form.vehicles.engineType.electro'),
                value: EngineType.ELECTRO,
            },
        ];
    }
    EngineType.createOptions = createOptions;
    function translate(t, value) {
        if (value === null)
            return '';
        return t(`wheelie:form.vehicles.engineType.${value}`);
    }
    EngineType.translate = translate;
})(EngineType || (EngineType = {}));
export var LicensePlateType;
(function (LicensePlateType) {
    LicensePlateType["NORMAL"] = "normal";
    LicensePlateType["INTERCHANGEABLE"] = "interchangeable";
    LicensePlateType["TRIAL"] = "trial";
})(LicensePlateType || (LicensePlateType = {}));
(function (LicensePlateType) {
    function createOptions(t) {
        return [
            {
                label: t('wheelie:form.vehicles.licensePlateType.ek'),
                value: LicensePlateType.NORMAL,
            },
            {
                label: t('wheelie:form.vehicles.licensePlateType.wk'),
                value: LicensePlateType.INTERCHANGEABLE,
            },
        ];
    }
    LicensePlateType.createOptions = createOptions;
    function getValues() {
        // TODO: TRIAL is not used right now
        return [LicensePlateType.NORMAL, LicensePlateType.INTERCHANGEABLE];
    }
    LicensePlateType.getValues = getValues;
})(LicensePlateType || (LicensePlateType = {}));
export var FirstRegistrationBeforeEcoTaxReform;
(function (FirstRegistrationBeforeEcoTaxReform) {
    FirstRegistrationBeforeEcoTaxReform["AFTER_01102020"] = "after01102020";
    FirstRegistrationBeforeEcoTaxReform["BEFORE_30092020"] = "before30092020";
    FirstRegistrationBeforeEcoTaxReform["NO_SELECTION"] = "noselection";
})(FirstRegistrationBeforeEcoTaxReform || (FirstRegistrationBeforeEcoTaxReform = {}));
(function (FirstRegistrationBeforeEcoTaxReform) {
    function isEmpty(value) {
        return value === FirstRegistrationBeforeEcoTaxReform.NO_SELECTION;
    }
    FirstRegistrationBeforeEcoTaxReform.isEmpty = isEmpty;
    function getValue(value) {
        if (value === FirstRegistrationBeforeEcoTaxReform.NO_SELECTION) {
            return null;
        }
        return value;
    }
    FirstRegistrationBeforeEcoTaxReform.getValue = getValue;
    function createOptions(t) {
        return [
            {
                label: FirstRegistrationBeforeEcoTaxReform.translate(t, FirstRegistrationBeforeEcoTaxReform.BEFORE_30092020),
                value: FirstRegistrationBeforeEcoTaxReform.BEFORE_30092020,
            },
            {
                label: FirstRegistrationBeforeEcoTaxReform.translate(t, FirstRegistrationBeforeEcoTaxReform.AFTER_01102020),
                value: FirstRegistrationBeforeEcoTaxReform.AFTER_01102020,
            },
        ];
    }
    FirstRegistrationBeforeEcoTaxReform.createOptions = createOptions;
    function translate(t, value) {
        switch (value) {
            case FirstRegistrationBeforeEcoTaxReform.BEFORE_30092020:
                return t('wheelie:form.enum.firstRegistrationBeforeEcoTaxReform.before30092020');
            case FirstRegistrationBeforeEcoTaxReform.AFTER_01102020:
                return t('wheelie:form.enum.firstRegistrationBeforeEcoTaxReform.after01102020');
            default:
                return '';
        }
    }
    FirstRegistrationBeforeEcoTaxReform.translate = translate;
})(FirstRegistrationBeforeEcoTaxReform || (FirstRegistrationBeforeEcoTaxReform = {}));
export var PreviousDamage;
(function (PreviousDamage) {
    PreviousDamage["NO_PREV_DAMAGE"] = "noPrevDamage";
    PreviousDamage["NO_PREV_DAMAGEREPORT_ATTACHED"] = "noPrevDamageReportAttached";
    PreviousDamage["UNSELECTED_STATE"] = "unselectedState";
    PreviousDamage["VEHICLE_WITH_EXISTING_ZURICH_CASCO"] = "vehicleWithExistingZurichCasco";
    PreviousDamage["WITH_PREV_DAMAGE"] = "withPrevDamage";
    PreviousDamage["WITH_PREV_DAMAGEREPORT_ATTACHED"] = "withPrevDamageReportAttached";
})(PreviousDamage || (PreviousDamage = {}));
(function (PreviousDamage) {
    function isEmpty(value) {
        return value === PreviousDamage.UNSELECTED_STATE;
    }
    PreviousDamage.isEmpty = isEmpty;
    function getValue(value) {
        if (value === PreviousDamage.UNSELECTED_STATE) {
            return null;
        }
        return value;
    }
    PreviousDamage.getValue = getValue;
    function createOptions(t) {
        return [
            {
                label: t(`wheelie:form.enum.vehiclePreviousDamage.${PreviousDamage.NO_PREV_DAMAGE}`),
                value: PreviousDamage.NO_PREV_DAMAGE,
            },
            {
                label: t(`wheelie:form.enum.vehiclePreviousDamage.${PreviousDamage.WITH_PREV_DAMAGE}`),
                value: PreviousDamage.WITH_PREV_DAMAGE,
            },
            {
                label: t(`wheelie:form.enum.vehiclePreviousDamage.${PreviousDamage.VEHICLE_WITH_EXISTING_ZURICH_CASCO}`),
                value: PreviousDamage.VEHICLE_WITH_EXISTING_ZURICH_CASCO,
            },
        ];
    }
    PreviousDamage.createOptions = createOptions;
})(PreviousDamage || (PreviousDamage = {}));
export var NoOfSeats;
(function (NoOfSeats) {
    NoOfSeats[NoOfSeats["ONE"] = 1] = "ONE";
    NoOfSeats[NoOfSeats["TWO"] = 2] = "TWO";
})(NoOfSeats || (NoOfSeats = {}));
(function (NoOfSeats) {
    function createOptions() {
        return [
            { label: '1', value: NoOfSeats.ONE },
            { label: '2', value: NoOfSeats.TWO },
        ];
    }
    NoOfSeats.createOptions = createOptions;
})(NoOfSeats || (NoOfSeats = {}));
